import React, { FC } from "react";
import { BasicNodeLayout, DocumentSchemaSource, NodeSize, NodeType, NodeTypeCategory } from "../Base";
import { NodeProps } from "reactflow";
import { DataType } from "../TypeDefinitions";
import { NodeConfigPropertyType } from "../../FlowDocument/PropertyTypeDefinitions";
import { noReferenceSchemaId } from "../DataSchemas";
import { camelCaseToReadable } from "../../Util/NodeUtil";

const nodeLabel = "To Reference";
const referenceOutputName = "result";
const unconnectedReferenceOutputLabel = "Connect Reference";
const referenceLabel = "Reference";
const referenceSchemaIdProperty = "referenceSchemaId";
const schemaNameProperty = "schemaName";
const schemaPropertyNameProperty = "schemaPropertyName";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.convertToReference,
  label: nodeLabel,
  featureToggle: `feat-core-2380-flows-ui-events`,
  category: NodeTypeCategory.transformations,
  hideLabelOnAnchor: true,
  controlOutputs: [],
  adaptToReferenceSchemaOnConnection: { resetOnDisconnect: false },
  documentDataInputListName: "inputs",
  inputsSchemaProperties: { identifiersOnly: true, schemaPropertyName: referenceSchemaIdProperty },
  dataInputs: [],
  // When schemaId is no reference, it will adapt to the connected reference schema upon connection.
  dataOutputs: [{ name: referenceOutputName, type: DataType.OBJECTREFERENCE, schemaId: noReferenceSchemaId }],
  nodeConfigProperties: [
    {
      name: referenceSchemaIdProperty,
      label: referenceLabel,
      propertyType: NodeConfigPropertyType.Schema,
      options: { linkedOutput: referenceOutputName, referenceOnly: true, displayProperty: schemaNameProperty },
      schemaSourceSystemType: DocumentSchemaSource.schemaPicker
    },
    {
      name: schemaNameProperty,
      propertyType: NodeConfigPropertyType.NoInput
    },
    {
      name: "identifier",
      propertyType: NodeConfigPropertyType.SchemaProperty,
      options: {
        schemaIdProperty: referenceSchemaIdProperty,
        identifierOnly: true,
        displayProperty: schemaPropertyNameProperty
      }
    },
    {
      name: schemaPropertyNameProperty,
      propertyType: NodeConfigPropertyType.NoInput
    },
    {
      name: "inputs",
      sectionName: "Inputs",
      propertyType: NodeConfigPropertyType.EnabledInputs
    }
  ],
  size: NodeSize.Small,
  evaluate: () => {
    return { output: {}, activeControlHandleIds: [] };
  }
});

export const ConvertToReferenceNode: FC<NodeProps> = ({ id, data }) => {
  const referenceName = data.nodeProperties[schemaNameProperty];
  let label = nodeLabel;
  if (referenceName) {
    const readableReferenceName = camelCaseToReadable(referenceName);
    label = "To " + readableReferenceName + " Reference";
    data.nodeProperties.outputs[referenceOutputName].label = readableReferenceName;
  } else {
    data.nodeProperties.outputs[referenceOutputName].label = unconnectedReferenceOutputLabel;
  }
  data.nodeProperties.label = label;
  return <BasicNodeLayout id={id} data={data} label={label} />;
};
